
let userProfile = null;

export const setUserProfile = (profile) => {
    userProfile = profile
} 

export const getUserProfile = () => {
    return userProfile; 
} 